import {DataObjectId} from 'yougile-model'
import {Hub} from 'yougile-model'
import {PageService} from '@extensions/page-service'
import {Item, ItemType} from '../item'
import {UIElement} from '../ui-element'
import {UIRegistry} from '../ui-registry'

export const browserInitItem = () => {
  const getUi = (companyId: DataObjectId, id: DataObjectId) => {
    const uiReg = UIRegistry.get(companyId)
    const old = uiReg.uiRegistry.get(id)
    if (old) {
      return old
    } else {
      const el = new UIElement(companyId, id, undefined)
      uiReg.uiRegistry.set(id, el)
      return el
    }
  }

  const open = (
    id: DataObjectId,
    type: ItemType,
    getHub: (id: DataObjectId) => Hub
  ) => {
    const hub = getHub(id)
    if (type === 'Company') {
      return
    } else if (type === 'Project') {
      PageService.goToProject(hub)
    } else if (type === 'Board') {
      PageService.goToBoard(hub)
    } else if (type === 'Column') {
      const board = getHub(hub.location)
      PageService.goToBoard(board)
    } else if (type === 'Task') {
      const col = getHub(hub.location)
      const board = getHub(col.location)
      PageService.goToBoard(board)
    } else {
      return
    }
  }

  Item.init(getUi, open)
}
